import React from "react";
import CodeRain from "../components/CodeRain";
import BackButton from "../components/BackButton";
import "./Mobilappar.css";

import flygvapnetLogo from "../assets/ic_launcher_LOGONEW.png";
import cleanpfasLogo from "../assets/cleanpfas LOGO icon (Android) 512x512.png";
import ratLogo from "../assets/LOGO RAT 512x512.png";
import worldMeditationLogo from "../assets/WorldMeditationICON.webp";

const Mobilappar = () => {
  return (
    <div className="mobilappar-page">
      <CodeRain />
      <div className="mobilappar-content">
        <BackButton label="Back to Projects" />

        <h1>Mobile Apps</h1>

        <p>
          Four mobile applications built with React Native and published to Google Play -
          delivered for real clients across higher education, healthcare, defence, and
          environmental sectors. Each engagement had distinct requirements, from content
          management workflows to geospatial data visualisation.
        </p>

        {/* World Meditation */}
        <div className="app-section">
          <div className="app-header">
            <img src={worldMeditationLogo} alt="World Meditation Logo" className="app-logo" />
            <h2>World Meditation</h2>
          </div>
          <p>
            Delivered for an Irish university. The app provides curated meditation and
            relaxation audio tracks, with a built-in content management workflow:
            contributors submit tracks, which admins review and approve before publication.
            Designed for institutional deployment with a clean, accessible UX.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.worldmeditation"
            target="_blank"
            rel="noopener noreferrer"
            className="app-link"
          >
            View on Google Play
          </a>
        </div>

        {/* Relationship Awareness Test */}
        <div className="app-section">
          <div className="app-header">
            <img src={ratLogo} alt="Relationship Awareness Test Logo" className="app-logo" />
            <h2>Relationship Awareness Test</h2>
          </div>
          <p>
            A clinical assessment tool used by therapists in professional practice. Built
            around a validated psychological framework, the app guides users through a
            structured relationship awareness test and presents results in a clear,
            interpretable format.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.linespotting.rattest"
            target="_blank"
            rel="noopener noreferrer"
            className="app-link"
          >
            View on Google Play
          </a>
        </div>

        {/* Clean PFAS */}
        <div className="app-section">
          <div className="app-header">
            <img src={cleanpfasLogo} alt="Clean PFAS Logo" className="app-logo" />
            <h2>Clean PFAS</h2>
          </div>
          <p>
            Geospatial data visualisation app mapping PFAS contamination sites worldwide.
            Integrates interactive map rendering with a curated environmental dataset, making
            complex pollution data accessible to the general public and policy stakeholders.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.cleanpfasorg.pfasmap"
            target="_blank"
            rel="noopener noreferrer"
            className="app-link"
          >
            View on Google Play
          </a>
        </div>

        {/* Swedish Air Force */}
        <div className="app-section">
          <div className="app-header">
            <img src={flygvapnetLogo} alt="Swedish Air Force Meditation Logo" className="app-logo" />
            <h2>Swedish Air Force Meditation</h2>
          </div>
          <p>
            A mental health and recovery app developed in collaboration with the Swedish
            Armed Forces' wellbeing programme. Built to support operational personnel with
            guided meditation and recovery sessions - reliability and simplicity were the
            primary design constraints.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.heliameditationapp"
            target="_blank"
            rel="noopener noreferrer"
            className="app-link"
          >
            View on Google Play
          </a>
        </div>
      </div>
    </div>
  );
};

export default Mobilappar;
